import { LogisticServicesLockBadge } from '@modules/current-user/components/logistic-services/badges/logistic-services-lock-badge';
import { LogisticServicesLoginBadge } from '@modules/current-user/components/logistic-services/badges/logistic-services-login-badge';
import { LogisticServicesTrafficLightBadge } from '@modules/current-user/components/logistic-services/badges/logistic-services-traffic-light-badge';

export const renderLogisticServiceBadge = ({ isActive, isFastDelivery }: { isActive: boolean; isFastDelivery: boolean }) => {
  return isFastDelivery ? <LogisticServicesTrafficLightBadge /> : isActive ? <LogisticServicesLoginBadge /> : <LogisticServicesLockBadge />;
};

